import {
  Alert,
  AlertColor,
  Autocomplete,
  Box,
  FormControlLabel,
  Grid,
  Snackbar,
  Switch,
  TextField,
} from '@mui/material'
import { PermissionType } from 'api/models/Common/JyrneyEnums'
import SectionHeader from 'components/Common/SectionHeader'
import Form from 'components/RouteWizard/Form'
import { Select } from 'components/RouteWizard/Select'
import { useRef, useState } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { getUser, updateUser } from 'reducers/usersReducer'
import schema from './delegateSchema'

interface UpdateUserDelegateProps {
  clientUsers: any
  userId?: integer
}

export const UpdateUserDelegate = (props: UpdateUserDelegateProps) => {
  const dispatch = useDispatch()
  const [alertMessage, setAlertMessage] = useState('')
  const [alertType, setAlertType] = useState<AlertColor>()
  const [showAlert, setShowAlert] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showAdditionalSettings, setShowAdditionalSettings] = useState(false)
  const formMethods = useRef<UseFormReturn | null>(null)

  const onSubmit = async (data: any) => {
    setIsLoading(true)
    console.log('UpdateUserDelegate: onSubmit', data)
    try {
      const startDateTime = showAdditionalSettings
        ? new Date(
            new Date(data.startDateTime).toLocaleString('en-US', {
              timeZone: data.timezone,
            }),
          ).toISOString()
        : null
      const endDateTime = showAdditionalSettings
        ? new Date(
            new Date(data.endDateTime).toLocaleString('en-US', {
              timeZone: data.timezone,
            }),
          ).toISOString()
        : null

      const user = props.clientUsers.find(
        (user: any) => user.id === data.userId.id,
      )
      console.log('UpdateUserDelegate: user', user)
      const existingDelegates = user.delegates || []
      console.log('UpdateUserDelegate: existingDelegates', existingDelegates)
      const updatedDelegates = existingDelegates.map((delegate: any) => ({
        permissionTypeName: delegate.permissionTypeName,
        delegateId: delegate.delegate.delegateId,
        startDateTime: delegate.delegate.startDateTime,
        endDateTime: delegate.delegate.endDateTime,
      }))
      console.log('UpdateUserDelegate: updatedDelegates', updatedDelegates)

      await updateUser({
        updatedUser: {
          delegates: [
            ...updatedDelegates,
            {
              permissionTypeName: data.permissionTypeName,
              delegateId: data.delegateId.id,
              startDateTime,
              endDateTime,
            },
          ],
        },
        userid: data.userId.id,
      })

      setShowAlert(true)
      setAlertMessage('Profile Updated')
      setAlertType('success')
      dispatch(getUser())
      setIsLoading(false)
    } catch (error) {
      setShowAlert(true)
      setAlertMessage('No updates made')
      setAlertType('error')
      setIsLoading(false)
    }
  }

  console.log('UpdateUserDelegate: clientUsers', props)

  const getDefaultUser = () => {
    return (
      props.clientUsers?.find((opt: any) => opt.id === props.userId) || null
    )
  }

  const defaultValues = { userId: getDefaultUser() }

  const handleAlertClose = () => setShowAlert(false)

  console.log(
    'users timezone',
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  )

  const midnightTomorrowPlus7Days = new Date(
    new Date().setHours(23, 59, 59, 59) + 8 * 24 * 60 * 60 * 1000,
  )
  const midnightTomorrowPlus1Day = new Date(
    new Date().setHours(0, 0, 0, 0) + 2 * 24 * 60 * 60 * 1000,
  )

  console.log('midnightTomorrowPlus1Day', midnightTomorrowPlus1Day)
  console.log('midnightTomorrowPlus7Days', midnightTomorrowPlus7Days)

  return (
    <>
      <Box
        component="div"
        sx={{
          width: '100%',
          fontSize: '14px',
          backgroundColor: '#F8F8F8',
          color: '#8E8E8E',
          display: 'flex',
          flexShrink: 1,
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: '20px',
        }}
      >
        <Grid
          container
          style={{
            width: '90%',
            display: 'block',
            textAlign: 'left',
            paddingTop: '20px',
          }}
        >
          <Form
            isLoading={isLoading}
            schema={schema}
            defaultValues={{
              ...defaultValues,
              startDateTime: midnightTomorrowPlus1Day
                .toISOString()
                .slice(0, 16),
              endDateTime: midnightTomorrowPlus7Days.toISOString().slice(0, 16),
            }}
            ref={formMethods}
            onSubmit={onSubmit}
            submitText="Update"
          >
            <SectionHeader title="Add User Delegate" />
            <Controller
              name="userId"
              control={formMethods.current?.control}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  {...field}
                  options={props.clientUsers}
                  getOptionLabel={(option) =>
                    `${option.firstName} ${option.lastName} (${option.email})`
                  }
                  disabled={!!props.userId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select User"
                      variant="outlined"
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                  onChange={(_, value) => field.onChange(value)}
                />
              )}
            />
            <Controller
              name="delegateId"
              control={formMethods.current?.control}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Autocomplete
                    {...field}
                    options={props.clientUsers}
                    getOptionLabel={(option) =>
                      `${option.firstName} ${option.lastName} (${option.email})`
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Delegate User"
                        variant="outlined"
                        error={!!error}
                        helperText={error ? error.message : null}
                      />
                    )}
                    onChange={(_, value) => field.onChange(value)}
                  />
                </>
              )}
            />
            <Select
              name="permissionTypeName"
              label="Permission Type"
              // options={{
              //   FullControl: 'Full Control',
              //   ViewOnly: 'View Only',
              //   BookOnly: 'Book Only',
              // }}
              options={Object.entries(PermissionType).reduce(
                (acc, [key, value]) => {
                  acc[key] = value // Add the key-value pair
                  return acc
                },
                {} as { [key: string]: string },
              )}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={showAdditionalSettings}
                  onChange={() =>
                    setShowAdditionalSettings(!showAdditionalSettings)
                  }
                  color="primary"
                />
              }
              label={
                showAdditionalSettings
                  ? 'Hide Additional Settings'
                  : 'Show Additional Settings'
              }
            />
            {showAdditionalSettings && (
              <>
                <Controller
                  name="startDateTime"
                  control={formMethods.current?.control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Start Date and Time"
                      type="datetime-local"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputProps: {
                          placeholder: '',
                        },
                      }}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
                <Controller
                  name="endDateTime"
                  control={formMethods.current?.control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="End Date and Time"
                      type="datetime-local"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputProps: {
                          placeholder: '',
                        },
                      }}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
                <Controller
                  name="timezone"
                  control={formMethods.current?.control}
                  defaultValue={
                    Intl.DateTimeFormat().resolvedOptions().timeZone
                  }
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={Intl.supportedValuesOf('timeZone')}
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Timezone"
                          variant="outlined"
                        />
                      )}
                      onChange={(_, value) => field.onChange(value)}
                    />
                  )}
                />
              </>
            )}
          </Form>
        </Grid>
      </Box>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert
          onClose={handleAlertClose}
          severity={alertType}
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default UpdateUserDelegate
